import React, { Component } from 'react'

class RetornoNulo extends Component {
    render () {
        return (
           
                <div className="well text-center margin-botton-zero">
                    <b>{this.props.text}</b>
                </div>
           
        )
    }
}

RetornoNulo.defaultProps = {
	text     : 'Nâo foi encontrado nenhum registro.'
	
}

export default RetornoNulo;



// WEBPACK FOOTER //
// ./src/container/FlashRetornoNulo.js